export default __webpack_public_path__ + "static/media/Versus me - Give me One Reason.5c1e7092.wav";